import { z } from "zod";

export const contactSchema = z.object({
  name: z.string().min(2, "Le nom doit contenir au moins 2 caractères."),
  email: z.string().email("Adresse email invalide."),
  subject: z.enum(["Nouveau projet", "Collaboration", "Consulting", "Autre"]),
  message: z
    .string()
    .min(20, "Le message doit contenir au moins 20 caractères."),
});

export type ContactFormData = z.infer<typeof contactSchema>;

/** Payload serveur : champs visibles + anti-spam (honeypot, horodatage). */
export const contactSubmissionSchema = contactSchema.extend({
  company: z.string().optional(),
  startedAt: z.number().int(),
});

export type ContactSubmission = z.infer<typeof contactSubmissionSchema>;
